const hostnameEnvMappings = {
  'tam.kaiconversations.ai': 'live',
  'tam.root.kaiconversations.ai': 'production',
  //'app.test.kaiconversations.ai': 'production',
  'tam.test.kaiconversations.ai': 'test',
  'tam.uat.kaiconversations.ai': 'uat',
  'tam.live.kaiconversations.ai': 'live',
  'tam.dev.kaiconversations.ai': 'dev',
  // 'app.local.kaiconversations.ai': 'development',
  localhost: 'development',
  frontend: 'localstack',
  // 'tam.local.kaiconversations.ai': 'livelocal'
  'tam.local.kaiconversations.ai': 'testlocal'
}

export const env = hostnameEnvMappings[window.location.hostname]
